/*
 * Every bounce from this app to Wix sign-in.
 *
 * `/symphony` is NOT a route — it is Identity's brand preset
 * (`login-react-app/src/utils/presets.ts`). The same page under a bare `/signin`
 * renders as generic Wix, so a missing segment is invisible in code review and in
 * every test that only asks "did we navigate": the user gets a fully working login
 * page that has simply left Symphony. Hence one module, so a new bounce cannot
 * reintroduce the bare form by copying a neighbour.
 *
 * `postLogin` is read client-side by the login app off the page URL, and the branded
 * path honours it exactly as the bare one does.
 */
const SYMPHONY_SIGNIN = 'https://users.wix.com/symphony/signin';

/** Sign-in, returning the user to `returnUrl` once they are back in. */
export function signinUrl(returnUrl: string): string {
  return `${SYMPHONY_SIGNIN}?postLogin=${encodeURIComponent(returnUrl)}`;
}

/**
 * The public Wix password-recovery page, opened in the login app's forgot-password
 * mode. `overrideLocale` is how that page is localized — it does not read ours.
 */
export function forgotPasswordUrl(locale: string): string {
  return `${SYMPHONY_SIGNIN}?forgotPassword=true&overrideLocale=${encodeURIComponent(locale)}`;
}
